/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Original_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select an audio or video file..." |
*
* @param {Audio_Embed_Export_Original_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_original_placeholder = /** @type {((inputs?: Audio_Embed_Export_Original_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Original_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un fichier audio ou vidéo...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Audio- oder Videodatei aus...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file audio o video...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите аудио- или видеофайл...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo de audio o vídeo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择音频或视频文件……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声ファイルまたは動画ファイルを選択してください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक ऑडियो या वीडियो फ़ाइल चुनें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um arquivo de áudio ou vídeo...")
	return /** @type {LocalizedString} */ ("Select an audio or video file...")
});